import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SessionState {
  activeStoreId: number | null;
  setActiveStoreId: (id: number | null) => void;
  clearActiveStore: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      activeStoreId: null,
      setActiveStoreId: (id) => set({ activeStoreId: id }),
      clearActiveStore: () => set({ activeStoreId: null }),
    }),
    {
      name: "session-storage",
      partialize: (state) => ({ activeStoreId: state.activeStoreId }),
    },
  ),
);
